/*
 Copyright 2013-2017 the original author or authors from the JHipster project.

 This file is part of the JHipster project, see https://jhipster.github.io/
 for more information.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MissingTranslationHandler, TranslateDefaultParser, TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { JHI_COMPONENTS, JHI_DIRECTIVES, JHI_PIPES } from './core-utils-components';
import { JhiLanguageService, JhiMissingTranslationHandler, JhiTranslateComponent } from './language';
import { JhiModuleConfig } from './config';
import { JhiConfigService } from './config.service';
import { JhiAlertService, JhiResolvePagingParams } from './service';
import { BUILD_TIMESTAMP } from '../../app.constants';

// Re export the files
export * from './pipe';
export * from './directive';
export * from './service';
export * from './component';
export * from './language';
export * from './config.service';
export * from './config';

export function translatePartialLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'content/i18n/', `.json?buildTimestamp=${BUILD_TIMESTAMP}`);
}

export function missingTranslationHandler(configService: JhiConfigService) {
    return new JhiMissingTranslationHandler(configService);
}

export class VisualTranslateParser extends TranslateDefaultParser {
    interpolate(expr: string | Function, params?: any): string {
        const result = super.interpolate(expr, params);
        // Wrap the result in visual markers
        return `🈂️[${result}]`;
    }
}

@NgModule({
    imports: [
        TranslateModule.forRoot({
            // parser: { provide: TranslateParser, useClass: VisualTranslateParser },
            loader: {
                provide: TranslateLoader,
                useFactory: translatePartialLoader,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useFactory: missingTranslationHandler,
                deps: [JhiConfigService]
            }
        }),
        CommonModule
    ],
    declarations: [
        ...JHI_PIPES,
        ...JHI_DIRECTIVES,
        ...JHI_COMPONENTS,
        JhiTranslateComponent
    ],
    exports: [
        ...JHI_PIPES,
        ...JHI_DIRECTIVES,
        ...JHI_COMPONENTS,
        JhiTranslateComponent,
        TranslateModule,
        CommonModule
    ]
})
export class CoreUtilsModule {
    static forRoot(moduleConfig: JhiModuleConfig): ModuleWithProviders<CoreUtilsModule> {
        return {
            ngModule: CoreUtilsModule,
            providers: [
                { provide: JhiLanguageService, useClass: JhiLanguageService },
                { provide: JhiResolvePagingParams, useClass: JhiResolvePagingParams },
                { provide: JhiAlertService, useClass: JhiAlertService },
                { provide: JhiModuleConfig, useValue: moduleConfig },
                { provide: JhiConfigService, useClass: JhiConfigService }
            ]
        };
    }
    static forChild(moduleConfig: JhiModuleConfig): ModuleWithProviders<CoreUtilsModule> {
        return {
            ngModule: CoreUtilsModule,
            providers: [
                { provide: JhiModuleConfig, useValue: moduleConfig },
            ]
        };
    }
}
